module.exports = __webpack_public_path__ + "static/media/icon_target.a2eb0f17.png";